import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import RedefineYourLimits from "./sections/RedefineYourLimits";
import TheNeuroEdge from "./sections/TheNeuroEdge";
import OurPerformancePillars from "./sections/OurPerformancePillars";
import PathToPeakPerformance from "./sections/PathToPeakPerformance";
import PerformanceResults from "./sections/PerformanceResults";
import AthleteSuccessStories from "./sections/AthleteSuccessStories";
import MovementMasteryFaq from "./sections/MovementMasteryFaq";
import StartYourRecovery from "./sections/StartYourRecovery";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <RedefineYourLimits />
      <TheNeuroEdge />
      <OurPerformancePillars />
      <PathToPeakPerformance />
      <PerformanceResults />
      <AthleteSuccessStories />
      <MovementMasteryFaq />
      <StartYourRecovery />
      <Footer />
    </div>;
}